import React from 'react';
export function Footer() {
  return <footer className="py-12 bg-background border-t border-white/5 text-center" data-id="element-92">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-93">
        <div className="mb-8" data-id="element-94">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-95">
            🏍️ MEGA PACK MOTOCICLISTA™
          </h3>
          <p className="text-cyan font-medium mb-2" data-id="element-96">
            El sistema N°1 para motociclistas en Argentina.
          </p>
          <p className="text-gray-400" data-id="element-97">
            Porque rodar en moto no debería costarte todos los fines de semana
            del año.
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-gray-400 text-sm mb-12" data-id="element-98">
          <a href="mailto:soporte@megapackmotociclista.com" className="hover:text-cyan transition-colors" data-id="element-99">
            📧 soporteoficialfegion@gmail.com
          </a>
          <span className="hidden md:inline text-white/10" data-id="element-100">|</span>
          <a href="#" className="hover:text-cyan transition-colors" data-id="element-101">
            📲 @fegion
          </a>
          <span className="hidden md:inline text-white/10" data-id="element-102">|</span>
          <a href="#" className="hover:text-cyan transition-colors" data-id="element-103">
            🌐 www.fegion.shop
          </a>
        </div>

        <div className="border-t border-white/5 pt-8" data-id="element-104">
          <p className="text-gray-500 text-sm mb-6" data-id="element-105">
            © Mega Pack Motociclista™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <div className="text-gray-600 text-sm italic space-y-1" data-id="element-106">
            <p data-id="element-107">🏍️ "El próximo fin de semana puede ser diferente."</p>
            <p data-id="element-108">
              "Porque tu moto te lleva lejos — pero solo si la cuidás bien."
            </p>
          </div>
        </div>
      </div>
    </footer>;
}